/**
 * Candidate detail / edit route helpers.
 * Pipeline stage is driven by candidate.status only — no ?stage= browsing.
 */

/**
 * Build location for candidate detail page.
 * @param {number|string} candidateId
 * @param {{ from?: string }} [opts]
 */
export function buildCandidateDetailLocation(candidateId, opts = {}) {
  const id = Number(candidateId);
  if (!Number.isInteger(id) || id <= 0) return null;

  const query = {};
  const from = String(opts.from || '').trim();
  if (from.startsWith('/') && !from.startsWith('//')) {
    query.from = from;
  }

  return {
    name: 'candidate-detail',
    params: { id: String(id) },
    query
  };
}

/**
 * Build location for candidate edit (detail + drawer).
 * @param {number|string} candidateId
 * @param {{ section?: string, from?: string }} [opts]
 */
export function buildCandidateEditLocation(candidateId, opts = {}) {
  const id = Number(candidateId);
  if (!Number.isInteger(id) || id <= 0) return null;

  const query = { edit: '1' };
  const from = String(opts.from || '').trim();
  if (from.startsWith('/') && !from.startsWith('//')) {
    query.from = from;
  }

  return {
    name: 'candidate-detail',
    params: { id: String(id) },
    query
  };
}

/**
 * Resolve safe return target after leaving candidate detail.
 * @param {import('vue-router').Router} router
 * @param {string} [rawFrom]
 */
export function resolveCandidateDetailReturnTarget(router, rawFrom) {
  const fallback = { name: 'candidates' };
  const from = String(rawFrom || '').trim();
  if (!from.startsWith('/') || from.startsWith('//')) return fallback;

  try {
    const resolved = router.resolve(from);
    const target = { path: resolved.path, query: resolved.query, hash: resolved.hash };
    const routeName = String(resolved.name || '');
    if (routeName === 'candidate-detail') return fallback;
    if (routeName === 'candidates' || routeName === 'dashboard' || routeName === 'employees' || routeName === 'documents') {
      return target;
    }
    if (resolved.path === '/candidates' || resolved.path.startsWith('/candidates?')) {
      return target;
    }
    return fallback;
  } catch {
    return fallback;
  }
}
